import type { BillingStatus } from "@/types/api";

export type DocumentListKind = "invoice_pdf" | "receipt" | "credit_note";

export interface PlanCapabilityFlags {
  canInlinePdf: boolean;
  canPaginate: boolean;
  canSelectionExport: boolean;
  canBulkExport: boolean;
  canPayLinksCsv: boolean;
  canRedownloadHistory: boolean;
}

const STARTER_CAPS: PlanCapabilityFlags = {
  canInlinePdf: true,
  canPaginate: true,
  canSelectionExport: true,
  canBulkExport: false,
  canPayLinksCsv: true,
  canRedownloadHistory: true,
};

const PRO_CAPS: PlanCapabilityFlags = {
  canInlinePdf: true,
  canPaginate: true,
  canSelectionExport: true,
  canBulkExport: true,
  canPayLinksCsv: true,
  canRedownloadHistory: true,
};

/** Product SSOT mirror of backend PlanCapabilities.forVipLevel. */
export function planCapabilitiesForVip(vipLevel: string): PlanCapabilityFlags {
  const level = vipLevel.trim().toLowerCase();
  if (level === "pro" || level === "business") {
    return PRO_CAPS;
  }
  return STARTER_CAPS;
}

export function canPaginateList(
  vipLevel: string,
  _listKind: DocumentListKind,
): boolean {
  return planCapabilitiesForVip(vipLevel).canPaginate;
}

export function canSelectionExportList(
  vipLevel: string,
  _listKind: DocumentListKind,
): boolean {
  return planCapabilitiesForVip(vipLevel).canSelectionExport;
}

/** vip_level is the persisted entitlement SSOT from GET /billing/status. */
export function effectiveVipLevel(status: BillingStatus): string {
  const stored = status.vip_level?.trim().toLowerCase() ?? "";
  if (stored === "pro" || stored === "business") {
    return stored;
  }
  return "starter";
}

export function resolvePlanCapabilities(status: BillingStatus | undefined): PlanCapabilityFlags {
  if (!status) {
    return planCapabilitiesForVip("starter");
  }
  return planCapabilitiesForVip(effectiveVipLevel(status));
}
